export default "__VITE_ASSET__BsVgrCr8__"